import React, {useState} from "react";
import {withNamespaces} from "react-i18next";
import {Link, useLocation} from "react-router-dom";
import {mainConfig} from "../../config";
import LanguageSwitcher from "./LanguageSwitcher";
import PlatformNewsLink from "./PlatformNewsLink";
import {landingNavigation} from "../../config/landing-navigation.config";
import {
    getLandingSectionHref,
} from "../../presentation/public-site/route-policy";

function MenuIcon({opened}) {
    if (opened) {
        return (
            <svg
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z"
                    fill="currentColor"
                />
            </svg>
        );
    }

    return (
        <svg
            width="19"
            height="13"
            viewBox="0 0 19 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M0 0H19V1H0V0ZM0 6H19V7H0V6ZM19 12H0V13H19V12Z"
                fill="currentColor"
            />
        </svg>
    );
}

function LandingHeaderContent({t}) {
    const location = useLocation();
    const [isMenuOpen, setMenuOpen] = useState(false);

    const closeMenu = () => {
        setMenuOpen(false);
    };

    return (
        <div
            className={`container header-shell__content landing-header${isMenuOpen ? " landing-header--menu-open" : ""}`}
        >
            <div className="header__block header__block--top">
                <a
                    className="logo"
                    href="/"
                    aria-label={t("main.landing.header.logoAriaLabel")}
                >
                    <img
                        src="/img/svg/logo.svg"
                        alt={mainConfig.companyName}
                    />
                </a>

                <nav
                    className="landing-header__nav"
                    aria-label={t("main.landing.header.navigationAriaLabel")}
                >
                    {landingNavigation.map((item) => (
                        <a
                            href={getLandingSectionHref(
                                location.pathname,
                                item.id
                            )}
                            key={item.id}
                        >
                            {t(item.labelKey)}
                        </a>
                    ))}
                </nav>

                <div className="landing-header__actions">
                    <Link
                        className="header__login-link landing-header__login"
                        to="/login"
                    >
                        {t("main.landing.header.login")}
                    </Link>

                    <Link
                        className="landing-header__trial"
                        to="/register"
                    >
                        <span className="landing-header__trial-desktop">
                            {t("main.landing.header.trialDesktop")}
                        </span>

                        <span className="landing-header__trial-mobile">
                            {t("main.landing.header.trialMobile")}
                        </span>

                        <svg
                            width="17"
                            height="17"
                            viewBox="0 0 17 17"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M3.5415 8.5H13.4582M13.4582 8.5L9.56234 4.60417M13.4582 8.5L9.56234 12.3958"
                                stroke="currentColor"
                                strokeWidth="1.6"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                    </Link>
                </div>
            </div>

            <div className="header__block header__block--bottom">
                <button
                    className="header__mobile-button"
                    type="button"
                    aria-controls="landing-mobile-navigation"
                    aria-expanded={isMenuOpen}
                    onClick={() => setMenuOpen((opened) => !opened)}
                >
                    <MenuIcon opened={isMenuOpen}/>
                    <span>{t("main.landing.header.menu")}</span>
                </button>

                <nav
                    className="landing-header__secondary-nav"
                    aria-label={t(
                        "main.landing.header.navigationAriaLabel"
                    )}
                >
                    <Link to="/service/instruction">
                        {t("main.header.submenu.instruction")}
                    </Link>

                    <PlatformNewsLink className="landing-header__news-link"/>
                </nav>

                <LanguageSwitcher/>
            </div>

            {isMenuOpen && (
                <div
                    className="header__block header__block--mobile"
                    id="landing-mobile-navigation"
                >
                    <nav
                        className="landing-header__mobile-nav"
                        aria-label={t("main.landing.header.mobileNavigationAriaLabel")}
                    >
                        {landingNavigation.map((item) => (
                            <a
                                href={getLandingSectionHref(
                                    location.pathname,
                                    item.id
                                )}
                                onClick={closeMenu}
                                key={item.id}
                            >
                                {t(item.labelKey)}
                            </a>
                        ))}

                        <Link
                            className="landing-header__mobile-instruction"
                            to="/service/instruction"
                            onClick={closeMenu}
                        >
                            {t("main.header.submenu.instruction")}
                        </Link>

                        <PlatformNewsLink
                            className="landing-header__mobile-news"
                            onClick={closeMenu}
                        />

                        <Link
                            className="landing-header__mobile-login"
                            to="/login"
                            onClick={closeMenu}
                        >
                            {t("main.landing.header.mobileLogin")}
                        </Link>

                        <Link
                            className="landing-header__mobile-trial"
                            to="/register"
                            onClick={closeMenu}
                        >
                            {t("main.landing.header.mobileTrial")}
                        </Link>
                    </nav>
                </div>
            )}
        </div>
    );
}

export default withNamespaces("translation")(LandingHeaderContent);
